import React from 'react';
import Icon from '../../../components/AppIcon';

const WhyChooseUs = () => {
  const benefits = [
    {
      id: 1,
      icon: "DollarSign",
      title: "Best Prices",
      description: "Save up to 40% compared to traditional rental companies with competitive peer-to-peer pricing"
    },
    {
      id: 2,
      icon: "Shield",
      title: "Secure & Protected",
      description: "Every rental is covered by comprehensive verification of  Auto Insurance and verified owner profiles"
    },
    {
      id: 3,
      icon: "MapPin",
      title: "Local Availability",
      description: "Find trailers near you with thousands of listings across all 50 states"
    },
    {
      id: 4,
      icon: "Clock",
      title: "Flexible Rentals",
      description: "Rent by the day, week, or month with flexible pickup and return times"
    },
    {
      id: 5,
      icon: "Users",
      title: "Trusted Community",
      description: "Join thousands of verified users with real reviews and ratings"
    },
    {
      id: 6,
      icon: "Headphones",
      title: "24/7 Support",
      description: "Communicate with Owners/Renters anytime during your rental "
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground mb-3 md:mb-4">
            Why Choose Draggin Trailers?
          </h2>
          <p className="font-body text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Experience the future of trailer rentals with our peer-to-peer marketplace
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {benefits?.map((benefit) => (
            <div
              key={benefit?.id}
              className="bg-card rounded-lg p-6 md:p-8 shadow-elevation-2 transition-smooth hover:shadow-elevation-3"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name={benefit?.icon} size={24} color="var(--color-primary)" strokeWidth={2} className="md:w-7 md:h-7" />
                </div>

                <div className="flex-1">
                  <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground mb-2">
                    {benefit?.title}
                  </h3>
                  <p className="font-body text-sm md:text-base text-muted-foreground">
                    {benefit?.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;